module.exports = __webpack_public_path__ + "img/acasia.c1178ce9.png";